module.exports = __webpack_public_path__ + "img/C1-1.png";